module.exports = __webpack_public_path__ + "videos/7.c3e76ab.mp4";